import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import simantau from "../../../Assets/Projects/IoT/Simantau1.png";
import simantau2 from "../../../Assets/Projects/IoT/Simantau2.png";
import simantau3 from "../../../Assets/Projects/IoT/Simantau3.png";
import simantau4 from "../../../Assets/Projects/IoT/Simantau4.png";
import simantau5 from "../../../Assets/Projects/IoT/Simantau5.png";
import simantau6 from "../../../Assets/Projects/IoT/Simantau6.jpeg";

function SIMANTAU() {
  return (
    <ProjectDetailCard
      title="Simantau (Smart Agriculture Monitoring System)"
      image={simantau}
      screenshots={[simantau2, simantau3, simantau4]}
      description="
      SIMANTAU is an Internet of Things (IoT)-based smart agriculture monitoring system developed to monitor environmental conditions in real time. The system collects data from multiple sensors, including temperature, humidity, soil moisture, and other agricultural parameters, then displays the information through an interactive web dashboard. By providing continuous monitoring and real-time visualization, SIMANTAU helps users make faster and more accurate decisions to improve agricultural productivity and environmental management.
      "
      technologies={[
        "ESP32",
        "Arduino IDE",
        "C++",
        "DS18B20",
        "Soil Moisture Sensor",
        "NPK Sensor",
        "Firebase",
        "JavaScript",
        "IoT",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={simantau5} alt="gallery1" />
          <img src={simantau6} alt="gallery2" />
          <img src={simantau2} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default SIMANTAU;
